import { Routes, Route } from "react-router-dom";
import { ApplicationHome } from "../pages/ApplicationHome";
import { NoMatch } from "../pages/NoMatch";
import { ProtectedLayout } from "../layouts/ProtectedLayout";
import { PublicLayout } from "../layouts/PublicLayout";
import { Login } from "../pages/Login";
import { Signout } from "../pages/Signout";
import { Answer } from "../pages/Answer";
import { useAuth } from "../hooks/useAuth";
import { ApplicationMethod } from "../pages/ApplicationMethod";
import { Application } from "../pages/Application";
import { PersonDetail } from "../pages/PersonDetail";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { ApplicationInstruction } from "../pages/ApplicationInstruction";
import { ApplicationFormInstruction } from "../pages/ApplicationFormInstruction";
import { ApplicationContinue } from "../pages/ApplicationContinue";
import { MultipleApplication } from "../pages/MultipleApplication";
import { ApplicationCompletion } from "../pages/ApplicationCompletion";
import { ApplyNow } from "../pages/ApplyNow";
import { ApplicantDetails } from "../pages/ApplicantDetails";
import { Navbar } from "../components/Navbar/navbar";
import { Box } from "@mui/material";
import { Payment } from "../pages/Payment";
const Router = ({ application }) => {
    const { user, isAuthenticated, getUserDetailsNotAsync, refreshSessionData } = useAuth();
    const userData = getUserDetailsNotAsync();
    const path = "";
    const navigate = useNavigate();
    const [loaded, setLoaded] = useState(true);

    // const refreshSession = () => {
    //     refreshSessionData();
    //     // setLoaded(true);
    // };

    useEffect(() => {}, []);
    return (
        <>
            {loaded && (
                <Box sx={{ backgroundColor: "#fafaf5" }}>
                    <Navbar></Navbar>
                    <Routes>
                        <Route element={<PublicLayout />}>
                            <Route path="/login" element={<Login application={application} />} />
                            <Route path="/signout" element={<Signout />} />
                            <Route path="/answer" element={<Answer application={application} />}></Route>
                            <Route path="/personDetail" element={<PersonDetail />}></Route>
                            <Route path="/applicant-details" element={<ApplicantDetails />}></Route>
                            <Route path="*" element={<NoMatch />} />
                        </Route>

                        <Route path="/" element={<ProtectedLayout />}>
                            <Route path="/" element={<ApplicationHome></ApplicationHome>}></Route>
                            <Route path="/application" element={<Application />}></Route>
                            <Route path="/multiple-application" element={<MultipleApplication />}></Route>
                            <Route path="/application/:selectedTab/:step" element={<Application />}></Route>
                            <Route path="/application-method" element={<ApplicationMethod />}></Route>
                            <Route path="/application-instruction" element={<ApplicationInstruction />}></Route>
                            <Route path="/quick-check" element={<ApplicationFormInstruction />}></Route>
                            <Route path="/application-completion" element={<ApplicationCompletion />}></Route>
                            <Route path="/apply-now" element={<ApplyNow />}></Route>
                            <Route path="/payment" element={<Payment />}></Route>
                            <Route path="/application-continue" element={<ApplicationContinue />}></Route>
                            <Route path="*" element={<NoMatch />} />
                        </Route>
                    </Routes>
                </Box>
            )}
        </>
    );
};

export { Router };
